const getPurePersonaFromScore = scoreRaw => {
  const score = {
    P_RELIABLE: scoreRaw.P_RELIABLE,
    P_BALANCED: scoreRaw.P_BALANCED,
    P_DISRUPTIVE: scoreRaw.P_DISRUPTIVE,
    P_WITTY: scoreRaw.P_WITTY,
    P_PLAYFUL: scoreRaw.P_PLAYFUL,
  }

  const highestKey = Object.keys(score).reduce((a, b) =>
    score[a] > score[b] ? a : b
  )

  return highestKey
}

const getFlavorFromScore = scoreRaw => {
  const score = {
    F_CLASSIC: scoreRaw.F_CLASSIC,
    F_TRENDY: scoreRaw.F_TRENDY,
  }

  const highestKey = Object.keys(score).reduce((a, b) =>
    score[a] > score[b] ? a : b
  )

  return highestKey
}

const getPersonaFromScore = score => {
  if (score === null) return 1

  const flavor = getFlavorFromScore(score)
  const persona = getPurePersonaFromScore(score)

  if (flavor === "F_CLASSIC") {
    if (persona === "P_RELIABLE") return 1
    if (persona === "P_BALANCED") return 3
    if (persona === "P_DISRUPTIVE") return 5
    if (persona === "P_WITTY") return 7
    if (persona === "P_PLAYFUL") return 9
  } else if (flavor === "F_TRENDY") {
    if (persona === "P_RELIABLE") return 2
    if (persona === "P_BALANCED") return 4
    if (persona === "P_DISRUPTIVE") return 6
    if (persona === "P_WITTY") return 8
    if (persona === "P_PLAYFUL") return 10
  }

  return 1
}

const getPersonaLabel = id => {
  const labels = {
    1: "reliable & classic",
    2: "reliable & original",
    3: "kind & classic",
    4: "kind & original",
    5: "visionary & classic",
    6: "visionary & original",
    7: "witty & classic",
    8: "witty & original",
    9: "playful & classic",
    10: "playful & original",
  }
  if (labels.hasOwnProperty(id)) return labels[id]
  return "error loading persona"
}

const getPersonaLabelShort = id => {
  const labels = {
    1: "reliable",
    2: "reliable",
    3: "kind",
    4: "kind",
    5: "visionary",
    6: "visionary",
    7: "witty",
    8: "witty",
    9: "playful",
    10: "playful",
  }
  if (labels.hasOwnProperty(id)) return labels[id]
  return "error loading persona"
}

const PERSONAS = {
  P_RELIABLE: {
    index: 1,
    id: 1,
    title: "reliable",
    key: "P_RELIABLE",
  },
  P_BALANCED: {
    index: 3,
    id: 2,
    title: "kind",
    key: "P_BALANCED",
  },
  P_DISRUPTIVE: {
    index: 5,
    id: 3,
    title: "visionary",
    key: "P_DISRUPTIVE",
  },
  P_WITTY: {
    index: 7,
    id: 4,
    title: "witty",
    key: "P_WITTY",
  },
  P_PLAYFUL: {
    index: 9,
    id: 5,
    title: "playful",
    key: "P_PLAYFUL",
  },
}

const getSortedPersonas = (scores, currentId) => {
  const sorted = sortScores(scores)
  let result = []

  sorted.forEach(persona => {
    if (PERSONAS.hasOwnProperty(persona[0])) {
      let score = scores[persona[0]]

      if (
        getPurePersona(PERSONAS[persona[0]].index) === getPurePersona(currentId)
      )
        return

      if (score > 0)
        result.push({
          ...PERSONAS[persona[0]],
          score: scores[persona[0]],
        })
    }
  })

  return result
}

const sortScores = scores => {
  let sortable = []
  for (let key in scores) {
    sortable.push([key, scores[key]])
  }
  const sorted = sortable.sort((a, b) => b[1] - a[1])

  return sorted
}

const getPurePersona = personaId => {
  switch (parseInt(personaId)) {
    case 1:
    case 2:
      return 1
    case 3:
    case 4:
      return 3
    case 5:
    case 6:
      return 5
    case 7:
    case 8:
      return 7
    case 9:
    case 10:
      return 9
    default:
      return null
  }
}

const getPurePersonaLabel = personaId => {
  switch (parseInt(personaId)) {
    case 1:
    case 2:
      return "reliable"
    case 3:
    case 4:
      return "kind"
    case 5:
    case 6:
      return "visionary"
    case 7:
    case 8:
      return "witty"
    case 9:
    case 10:
      return "playful"
    default:
      return null
  }
}

const getNextPersonaId = (personaId, nextId) => {
  const flavor =
    [2, 4, 6, 8, 10].indexOf(personaId) > -1 ? "F_TRENDY" : "F_CLASSIC"
  if (flavor === "F_TRENDY") return nextId + 1
  return nextId
}

export {
  getFlavorFromScore,
  getNextPersonaId,
  getPersonaFromScore,
  getPurePersona,
  getPurePersonaLabel,
  getPurePersonaFromScore,
  getPersonaLabel,
  getPersonaLabelShort,
  getSortedPersonas,
}
